import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import CmsComponentImage from "@/helpers/editor/components/CmsComponentImage.js";
import CmsBlockMapRatingPopup from "@/helpers/editor/blocks/CmsBlockMapRatingPopup.js";
import CmsLink from "@/helpers/cms/CmsLink.js";

export default class CmsBlockMap extends CmsBlock {
    static typeDef = {
        name: `Wayfinding Map|Plan navigation`,
        glyph: `fas fa-map`,
        type: `map`,
        category: `widget`,
        isParent: true
    }

    static slotsDef = [
        {
            slot: `ratingPopup`,
            name: `Rating Popup|Fenêtre d'évaluation`,
            constructor: CmsBlockMapRatingPopup,
            required: false
        }
    ]

    constructor(data, page) {
        super(data, page);

        this.padding.init(0);

        this.floorDirectory = this.mergeDefaults(this.floorDirectory, {
            active: true
        });

        this.bannerImage = new CmsComponentImage(this.bannerImage);
        this.searchPageLink = this.searchPageLink ? new CmsLink(this.searchPageLink) : null;
    }
}
